let mainReqUrl = {
  "邓州": {
    prod: {
      cityName: "邓州市",
      reqBaseUrl: "http://1.192.106.56:10003"
    },
    dev: {}
  },
  "淅川": {
    prod: {
      cityName: "淅川县",
      reqBaseUrl: "http://1.192.106.56:10003",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
    },
    dev: {}
  },
  "新乡": {
    prod: {
      cityName: "新乡市",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "新乡高新区": {
    prod: {
      cityName: "新乡市高新区",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "封丘": {
    prod: {
      cityName: "封丘县",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "辉县": {
    prod: {
      cityName: "辉县市",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {
      cityName: "辉县市",
      reqBaseUrl: "http://39.164.142.214:10021",
    }
  },
  "牧野区": {
    prod: {
      cityName: "牧野区",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "获嘉": {
    prod: {
      cityName: "获嘉县",
      reqBaseUrl: "http://1.92.70.79:10033",
      socketUrl: "ws://1.92.70.79:10033",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
      imageBaseUrl3: "http://1.92.70.79:10019",
    },
    dev: {
      cityName: "获嘉县",
      reqBaseUrl: "http://39.164.142.214:10021",
      // reqBaseUrl: "http://192.168.0.20:8087",
      socketUrl: "ws://39.164.142.214:10021",
      // reqBaseUrl: "ws://192.168.0.20:8087",
    }
  },
  "凤泉区": {
    prod: {
      cityName: "凤泉",
      reqBaseUrl: "http://1.92.70.79:10033",
      socketUrl: "ws://1.92.70.79:10033",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
      imageBaseUrl3: "http://1.92.70.79:10019",
    },
    dev: {}
  },
  "延津": {
    prod: {
      cityName: "延津县",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "卫滨区": {
    prod: {
      cityName: "卫滨区",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "平原新区": {
    prod: {
      cityName: "新乡市平原城乡一体化示范区",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "许昌": {
    prod: {
      cityName: "许昌市",
      reqBaseUrl: "http://117.159.53.44:10003",
      socketUrl: "ws://117.159.53.44:10003",
    },
    dev: {
      cityName: "许昌市",
      reqBaseUrl: "http://39.164.142.214:10021",
      // reqBaseUrl: "http://192.168.0.20:8087",
      socketUrl: "ws://39.164.142.214:10021",
      // socketUrl: "ws://192.168.0.20:8087"
    }
  },
  "上蔡": {
    prod: {
      cityName: "上蔡县",
      reqBaseUrl: "http://1.192.106.56:10003"
    },
    dev: {}
  },
  "宁陵": {
    prod: {
      cityName: "宁陵县",
      reqBaseUrl: "http://117.159.53.44:10003"
    },
    dev: {}
  },
  "永城": {
    prod: {
      cityName: "永城市",
      reqBaseUrl: "http://117.159.53.44:10003"
    },
    dev: {}
  },
  "濮阳": {
    prod: {
      cityName: "濮阳市",
      reqBaseUrl: "http://1.192.106.56:10003",
    },
    dev: {
      cityName: "华龙区",
      reqBaseUrl: "http://39.164.142.214:10021",
      // reqBaseUrl: "http://192.168.0.20:8087",
      socketUrl: "ws://39.164.142.214:10021",
      // socketUrl: "ws://192.168.0.20:8087"
    }
  },
  "华龙区": {
    prod: {
      cityName: "濮阳市华龙区",
      reqBaseUrl: "http://1.192.106.56:10003",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
    },
    dev: {
      cityName: "华龙区",
      reqBaseUrl: "http://39.164.142.214:10021",
      // reqBaseUrl: "http://192.168.0.20:8087",
      socketUrl: "ws://39.164.142.214:10021",
      // socketUrl: "ws://192.168.0.20:8087"
    }
  },
  "范县": {
    prod: {
      cityName: "范县",
      reqBaseUrl: "http://1.192.106.56:10003",
    },
    dev: {
    }
  },
  "濮阳市一体化示范区": {
    prod: {
      cityName: "濮阳市一体化示范区",
      reqBaseUrl: "http://1.192.106.56:10003",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
    },
    dev: {
      cityName: "濮阳市一体化示范区",
      reqBaseUrl: "http://39.164.142.214:10021"
      // reqBaseUrl: "http://192.168.0.20:8087",
    }
  },
  "演示濮阳": {
    prod: {
      cityName: "演示濮阳",
      reqBaseUrl: "http://117.159.53.44:10003"
    },
    dev: {}
  },
  "信阳": {
    prod: {
      cityName: "信阳市",
      reqBaseUrl: "http://1.192.106.51:10003",
      socketUrl: "ws://1.192.106.51:10003"
    },
    dev: {
      cityName: "信阳市",
      reqBaseUrl: "http://192.168.0.20:8087"
    }
  },
  "长垣": {
    prod: {
      cityName: "长垣市",
      reqBaseUrl: "http://1.92.70.79:10033"
    },
    dev: {}
  },
  "清丰县": {
    prod: {
      cityName: "濮阳市清丰县",
      reqBaseUrl: "http://1.192.106.56:10003",
      imageBaseUrl: "http://1.192.106.56:10020",
      imageBaseUrl1: "http://117.159.15.203:16001",
      imageBaseUrl2: "http://117.159.15.203:16003",
    },
    dev: {
      cityName: "濮阳市清丰县",
      reqBaseUrl: "http://39.164.142.214:10021"
    }
  },
  "演示环境": {
    prod: {
      cityName: "演示环境",
      reqBaseUrl: "http://114.116.254.116:10093",
    },
    dev: {
    }
  },
  "卢氏": {
    prod: {
      cityName: "卢氏县",
      reqBaseUrl: "http://1.192.106.51:10003",
    },
    dev: {
    }
  },
}
module.exports = {
  mainReqUrl: mainReqUrl["平原新区"]["prod"]
}